import React, { Component } from 'react';
import ReactTable from 'react-table';
import { CustomPagination } from './common-react-table';
import { _generateCheckboxLookup, _generateTableColumns } from './table-helpers';
import debounce from 'lodash/debounce';

/////////////////////////////////////////////
/////// Custom React Table component for server side pagination
/////////////////////////////////////////////

const FILTER_QUERY_DEBOUNCE_RATE = 500;

export class PaginatedCFTable extends Component {
    constructor(props){
        super(props);

        var { data, columns } = this.props;

        this.state = {
          data: [],
          rows: {},
          pages: null,
          loading: true,
          shouldLoad: props.shouldInitialLoad
        };

        // `onFilteredChange` must call the SAME debounce function every "change"
        this.debounce = debounce(this.filteredFetch, FILTER_QUERY_DEBOUNCE_RATE);
        this.renderReactTable = this.renderReactTable.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        var { data, columns } = nextProps;
        var oldData = this.props.data;

        this.setState({ 
            data: nextProps.data ? nextProps.data : [],
            pages: nextProps.pages,
            shouldLoad: true,
            loading: false
        })
    }

    filteredFetch = () => {
        const { column, props: { filters, passUpFilters, fetchData, columnData }} = this;
        let customFilters = []

        //TODO: remove and make forecasts use multi-filter
        //this handles the case when multi-filter is not being used. Backwards compatible for forecasts
        filters.PropertyName = column[0] ? column[0].id : '';
        filters.Value = column[0] ? column[0].value : '';
        
        Object.keys(column).forEach(function (item, index) {
            
            let itemPropertyName = column[index] ? column[index].id : '';
            let itemValue = column[index] ? column[index].value : '';
            let itemProperties = columnData ? columnData[itemPropertyName] : {};

            if(itemValue !== '') {

                let operation = "Equals"; //default
                
                if(itemProperties) {
                    
                    if(itemProperties.columnOperation) { operation = itemProperties.columnOperation; }
                    
                    //TODO: remove itemPropertName and have dugout-promotions use dynamic properties
                    if(itemProperties.columnType && itemProperties.columnType === "Dropdown" || (itemPropertyName === "PriorityID" || itemPropertyName === "IsActive")) {
                        if(itemValue === "None") { operation = "None"; }   
                    }
                }
                
                customFilters.push({
                    PropertyName: itemPropertyName,
                    Value: itemValue,
                    Operation: operation
                });
            }
        });

        filters.customFilters = customFilters;
        this.setState({ filters })
        if(passUpFilters) { passUpFilters(filters); }
        filters.Page = 1;
        fetchData(filters);
    }

    renderReactTable() {
        var { columns, filterable, sortable, data, defaultSortAsc, defaultSortAccessor, showFilterBar } = this.props;
        var { rows, shouldLoad } = this.state;

        var _this = this;

        var dataArray = data;

        var columns = _generateTableColumns(columns, rows, data.length);

        var showFilterBar = !filterable && showFilterBar === true ? 'mock-filter-bar' : null;

        var className = "cf-reacttable -striped -highlight " + showFilterBar + (this.props.className ? (' ' + this.props.className) : '');

        var defaultSorted = [];

        if(defaultSortAsc != null && defaultSortAccessor != null){
            defaultSorted = [
                {
                    desc: defaultSortAsc,
                    id: defaultSortAccessor
                }
            ];
        };

        //this is meant to safely add additional table props without affecting base behavior.
        const { additionalProps = {} } = this.props;

        return (
            <ReactTable
                manual
                data={dataArray}
                columns={columns}
                className={className}
                filterable={filterable}
                sortable={sortable}
                defaultSorted={defaultSorted}
                defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value}
                showPageSizeOptions={false}
                showPageJump={true}
                onPageChange={(pageIndex) => { 
                    if(shouldLoad) {
                        // show the loading overlay
                        this.setState({loading: true});
                        
                        if(typeof(this.state.filters) !== 'undefined')
                        {
                            //this handles the case when multi-filter is not being used. Backwards compatible for forecasts
                            this.props.filters.PropertyName = this.state.filters.PropertyName;
                            this.props.filters.Value = this.state.filters.Value;
                            
                            //case for multi-filter used on History page of schedules
                            this.props.filters.customFilters = this.state.filters.customFilters;
                        }
                        
                        this.props.filters.Page = (pageIndex + 1);
                        this.props.fetchData(this.props.filters);
                    };
                }}
                defaultPageSize={this.props.pageSize}
                defaultFilterMethod={(filter, row, column) => 
                    {
                        const id = filter.pivotId || filter.id;
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
                    }
                }
                onSortedChange={(newSorted, column, shiftKey) => {

                    let sortColumn = newSorted[0].id;
                    if(sortColumn === "SID") {
                        sortColumn = "ID";
                    }
										
                    this.props.filters.SortColumn = sortColumn;
                    this.props.filters.SortOrder = newSorted[0].desc === true ? 'desc' : 'asc';

                    if(typeof(this.state.filters) !== 'undefined')
                    {
                        //this handles the case when multi-filter is not being used. Backwards compatible for forecasts
                        this.props.filters.PropertyName = this.state.filters.PropertyName;
                        this.props.filters.Value = this.state.filters.Value;
                        
                        //case for multi-filter used on History page of schedules. this is used to maintain the entered values in columns when doing a new search
                        this.props.filters.customFilters = this.state.filters.customFilters;
                    }

                    this.props.fetchData(this.props.filters);
                }}
                onFilteredChange={(column, value) => {
                    this.column = column;
                    this.debounce();
                }}
                minRows={1}
                resizable={typeof this.props.resizable !== "undefined" ? this.props.resizable : true}
                pages={this.props.pages ? this.props.pages : 1}
                page={this.props.page ? this.props.page - 1 : 1}
                totalRecords={this.props.totalCount}
                PaginationComponent={this.props.useCustomPagination && this.props.paginationComponent ? this.props.paginationComponent : CustomPagination}
                {...additionalProps}
            />
        )
    }

    render() {
        var table = this.renderReactTable();

        return (
            <div className='field_row'>
                { table }
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/table/paginated-react-table.js